
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import { CommonHeaderComponentModule } from '../../components/common-header/common-header.module';

@NgModule({
    declarations: [
        LoginPage,
    ],
    imports: [
        CommonHeaderComponentModule, IonicPageModule.forChild(LoginPage),
    ],
    exports: [
        LoginPage
    ]
})
export class LoginPageModule { }


// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts